import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ModalComponent } from 'app/components/modal/modal.component';
import { ServidorRecad } from 'app/model/servidorRecad';
import { ToastrService } from 'ngx-toastr';
import { AuxTransportePosRecadDTO } from './auxTransportePosRecadDTO';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import {PosCampanhaServiceAba10} from "../../../service/posCampanhaAba10/pos-campanha-aba10.service";
import {Observable} from "rxjs";

type DadosTabela = {
  descricao: string;
  informacaoSrh: string;
  informacaoRecad: string;
}

@Component({
  selector: 'app-aba10-posrecad',
  templateUrl: './aba10-posrecad.component.html',
  styleUrls: ['./aba10-posrecad.component.sass']
})
export class Aba10PosrecadComponent implements OnInit {

  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() botoesDesabilitadosAuxTransporte: EventEmitter<any> = new EventEmitter<any>();
  @Input() btnDesativadoAuxTransporte: boolean;
  displayedColumns: string[] = ['descricao', 'informacaoSrh', 'informacaoRecad'];
  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];

  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  auxTransporte: AuxTransportePosRecadDTO;
  salvo: boolean = false;
  panelOpenState = false;

  justificativa: string = '';
  isDisabledJustificativa: boolean = true
  recadServidorId: number;
  validacaoRecadId: number;

  constructor(private toasterService: ToastrService, public dialog: MatDialog, private posCampanhaService10: PosCampanhaServiceAba10) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = [];
    this.list = [];
    this.salvo = false;
    // this.justificativa = "";
    this.findAuxTransporte(this.servidor.id)
  }

  findAuxTransporte(recadServidorId: number) {
    this.getAuxTransporte(recadServidorId).subscribe(
        response => {
          if(response){
            this.auxTransporte = response
            this.dataSource.data = this.montarDadosTabela(response);
          } else {
            this.flExibirTab.emit(false);
          }
        },
        (error) => {
          console.error(error);
        }
    );
  }

  private getAuxTransporte(recadServidorId: number): Observable<AuxTransportePosRecadDTO> {
    return this.posCampanhaService10.getObterAuxTransporte(recadServidorId);
  }

  private montarDadosTabela(resp: AuxTransportePosRecadDTO): DadosTabela[] {
    this.list.push(
      {
        descricao: "Quantidade total de percursos",
        informacaoSrh:  resp.listaSrh.quantidadePercuso.toString(),
        informacaoRecad: resp.listaRecad.quantidadePercuso.toString(),

      },
      {
        descricao: "Código da Linha",
        informacaoSrh:  resp.listaSrh.linha,
        informacaoRecad: resp.listaRecad.linha,

      }
    );

    return this.list;
  }

  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          this.justificativa = justificativa;
          this.aprovar(3)
          this.botoesDesabilitadosAuxTransporte.emit(true);
        }
      }
    });
  }

  rejeitar(){
    this.isDisabledJustificativa = false
    this.openDialog();
  }

  aprovar(status){
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    * */
    this.botoesDesabilitadosAuxTransporte.emit(true);
    if(status == 1){
      this.justificativa = ''
    }
    let body = {
      id: this.servidor.id,
      status: status,
      justificativa: this.justificativa,
    }
    this.posCampanhaService10.postAuxTransporte(body).subscribe( resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    });
  }


}
